<template>
  <div class="zhxx">
    <el-dialog title="修改密码"
               :visible.sync="dialogVisible"
               width="400px"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form>
        <el-form-item label="原密码"
                      prop="pword">
          <el-input v-model="pword"
                    autocomplete="off"
                    style="height: 30px"
                    placeholder="原密码"
                    prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item label="新密码"
                      prop="newpword">
          <el-input v-model="newpword"
                    autocomplete="off"
                    style="height: 30px"
                    placeholder="新密码"
                    prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码"
                      prop="newpword2">
          <el-input v-model="newpword2"
                    autocomplete="off"
                    style="height: 30px"
                    placeholder="确认新密码"
                    prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary"
                   @click="xgpword" style="margin: 20px 0 0 0;">确 定</el-button>
      </span>
    </el-dialog>
    <div class="iteminfo"
         v-if="dwform.type==1">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
        <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>部直属单位排名</span><span>{{dwform.rank}}</span></div>
      <div class="useritem"><span>所属单位数量</span><span>{{dwform.department_count}}</span></div>
      <div class="useritem"><span>总人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <div class="iteminfo"
         v-if="dwform.type==2">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
        <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>所属单位数量</span><span>{{dwform.department_count}}</span></div>
      <div class="useritem"><span>总人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <div class="iteminfo"
         v-if="dwform.type==3">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
        <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>全国（市级）排名</span><span>{{dwform.rank}}</span></div>
      <div class="useritem"><span>所属单位数量</span><span>{{dwform.department_count}}</span></div>
      <div class="useritem"><span>总人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <div class="iteminfo"
         v-if="dwform.type==4">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
       <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>全国（县级）排名</span><span>{{dwform.rank}}</span></div>
      <div class="useritem"><span>所属单位数量</span><span>{{dwform.department_count}}</span></div>
      <div class="useritem"><span>总人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <div class="iteminfo"
         v-if="dwform.type==5">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
        <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>全国（单位）排名</span><span>{{dwform.rank}}</span></div>
      <!-- <div class="useritem"><span>所在省排名</span><span>{{dwform.rank1}}个</span></div>
      <div class="useritem"><span>所在市排名</span><span>{{dwform.rank2}}个</span></div>
      <div class="useritem"><span>所在县排名</span><span>{{dwform.rank3}}个</span></div> -->
      <div class="useritem"><span>本单位人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <div class="iteminfo"
         v-if="dwform.type==6">
      <div class="useritem"><span>账户名称</span><span>{{dwform.department}}</span>
        <el-button type="primary"
                   @click="dialogVisible=true">修改密码</el-button>
      </div>
      <div class="useritem"><span>竞赛总分</span><span>{{dwform.score_all}}</span></div>
      <div class="useritem"><span>所属单位数量</span><span>{{dwform.department_count}}</span></div>
      <div class="useritem"><span>总人数</span><span>{{dwform.member_count}}</span></div>
      <div class="useritem"><span>“五进”人数</span><span>{{dwform.wj_count}}</span></div>
    </div>
    <!--         <el-descriptions :border='true'
                     v-if="dwform.type==1">
      <el-descriptions-item label="账户名称">{{dwform.department}}</el-descriptions-item>
      <el-descriptions-item label="竞赛总分">{{dwform.score_all}}分</el-descriptions-item>
      <el-descriptions-item label="部直属单位排名">{{dwform.rank}}个</el-descriptions-item>
      <el-descriptions-item label="所属单位数量">{{dwform.department_count}}个</el-descriptions-item>
      <el-descriptions-item label="总人数">{{dwform.member_count}}人</el-descriptions-item>
      <el-descriptions-item label="“五进”人数">{{dwform.wj_count}}人</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :border='true'
                     v-if="dwform.type==2">
      <el-descriptions-item label="账户名称">{{dwform.department}}</el-descriptions-item>
      <el-descriptions-item label="竞赛总分">{{dwform.score_all}}分</el-descriptions-item>
      <el-descriptions-item label="所属单位数量">{{dwform.department_count}}个</el-descriptions-item>
      <el-descriptions-item label="总人数">{{dwform.member_count}}人</el-descriptions-item>
      <el-descriptions-item label="“五进”人数">{{dwform.wj_count}}人</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :border='true'
                     v-if="dwform.type==3">
      <el-descriptions-item label="账户名称">{{dwform.department}}</el-descriptions-item>
      <el-descriptions-item label="竞赛总分">{{dwform.score_all}}分</el-descriptions-item>
      <el-descriptions-item label="全国（市级）排名">{{dwform.rank}}个</el-descriptions-item>
      <el-descriptions-item label="所属单位数量">{{dwform.department_count}}个</el-descriptions-item>
      <el-descriptions-item label="本地区人数">{{dwform.member_count}}人</el-descriptions-item>
      <el-descriptions-item label="“五进”人数">{{dwform.wj_count}}人</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :border='true'
                     v-if="dwform.type==4">
      <el-descriptions-item label="账户名称">{{dwform.department}}</el-descriptions-item>
      <el-descriptions-item label="竞赛总分">{{dwform.score_all}}分</el-descriptions-item>
      <el-descriptions-item label="全国（县级）排名">{{dwform.rank}}个</el-descriptions-item>
      <el-descriptions-item label="所属单位数量">{{dwform.department_count}}个</el-descriptions-item>
      <el-descriptions-item label="本地区人数">{{dwform.member_count}}人</el-descriptions-item>
      <el-descriptions-item label="“五进”人数">{{dwform.wj_count}}人</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :border='true'
                     v-if="dwform.type==5">
      <el-descriptions-item label="账户名称">{{dwform.department}}</el-descriptions-item>
      <el-descriptions-item label="竞赛总分">{{dwform.score_all}}分</el-descriptions-item>
      <el-descriptions-item label="全国（单位）排名">{{dwform.rank}}个</el-descriptions-item>
      <el-descriptions-item label="所在省排名">{{dwform.rank1}}个</el-descriptions-item>
      <el-descriptions-item label="所在市排名">{{dwform.rank2}}个</el-descriptions-item>
      <el-descriptions-item label="所在县排名">{{dwform.rank3}}个</el-descriptions-item>
      <el-descriptions-item label="本单位人数">{{dwform.member_count}}人</el-descriptions-item>
      <el-descriptions-item label="“五进”人数">{{dwform.wj_count}}人</el-descriptions-item>
    </el-descriptions> -->
  </div>
</template>

<script>
import { xgword } from "@/utils/request";
export default {
  name: 'userInfo',
  props: ['dwform'],
  data () {
    return {
      dialogVisible: false,
      pword: '',
      newpword: '',
      newpword2:'',
      loginform: {}
    }
  },
  methods: {
    xgpword () {
      /* ?m=ias&c=temp&a=modifyDepartment&title=浙江省水利厅&pword=123456&newpword=123 */
      if (this.newpword!==this.newpword2) {
        this.$message.error('确认密码必须一致')
      } else {
              return xgword(this.loginform.title, this.pword, this.newpword).then(
        (res) => {
          if (res.data.errcode == -1) {
            this.$message.error('信息有误，请重新输入!');
          } else {
            this.$message({
              message: '密码修改成功!',
              type: 'success'
            });
            this.dialogVisible=false
            this.pword=''
            this.newpword=''
            this.newpword2=''
          }
        },
      )
      }

    },
  },
  created () {
    this.loginform = JSON.parse(localStorage.getItem('loginform'))
  },
}
</script>

<style lang="less" scoped>
.zhxx {
  padding: 20px;
}
.useritem {
  display: flex;
  width: 600px;
  position: relative;
  .el-button {
    position: absolute;
    right: 1%;
  }
  span {
    color: #909399;
  }
  & > span:nth-of-type(1) {
    flex: 1;
    border: 1px solid #ebeef5;
    background: #fafafa;
    display: flex;
    justify-content: center;
    padding: 15px;
  }
  & > span:nth-of-type(2) {
    flex: 3;
    border: 1px solid #ebeef5;
    padding: 15px;
    color: #606266;
    background: #fafafa;
  }
}
</style>